import { render, staticRenderFns } from "./StandarPageWithListNoData.vue?vue&type=template&id=de663bbc&scoped=true"
import script from "./StandarPageWithListNoData.vue?vue&type=script&lang=js"
export * from "./StandarPageWithListNoData.vue?vue&type=script&lang=js"
import style0 from "./StandarPageWithListNoData.vue?vue&type=style&index=0&id=de663bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de663bbc",
  null
  
)

export default component.exports